// src/utils/route-guard/ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const ProtectedRoute = ({ requiredPermission }) => {
  const { user, permissions, loading } = useAuth();
  console.log(
    "user =>",
    user,
    "permission =>",
    permissions,
    "loading=>",
    loading
  );
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    user &&
    (user.role === "owner" ||
      user.role === "AdminM" ||
      user.role === "AdminA") &&
    window.location.pathname.includes("admin")
  ) {
    Navigate({ to: "/pawn/dashboard_pawn", replace: true });
    return null;
  }

  if (requiredPermission && !permissions.includes(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
